function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "81",
  viewBox: "0 0 86 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1956_114153)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "1.833",
  y: "10",
  width: "26",
  height: "30",
  rx: "1.028",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.833 11.028c0-.568.46-1.028 1.029-1.028h23.943c.568 0 1.029.46 1.029 1.028v16.84h-26v-16.84z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1.833 11.028c0-.568.46-1.028 1.029-1.028h23.943c.568 0 1.029.46 1.029 1.028v16.84h-26v-16.84z",
  fill: "#E8EAED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.833 10h26-26zm26 18.868h-26v-2h26v2zm-26-1V10v17.868zm26-17.868v17.868V10z",
  fill: "#DDE0E4",
  mask: "url(#a)"
}), /*#__PURE__*/React.createElement("rect", {
  x: "2.98",
  y: "30.879",
  width: "21.989",
  height: "2.069",
  rx: "1.034",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "2.98",
  y: "34.332",
  width: "6.088",
  height: "2.069",
  rx: ".514",
  fill: "#59C3C3"
})), /*#__PURE__*/React.createElement("rect", {
  x: "1.333",
  y: "9.5",
  width: "26",
  height: "31",
  rx: "2.5",
  stroke: "#DDE0E4"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_1956_114153)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "30.834",
  y: "10",
  width: "26",
  height: "30",
  rx: "1.028",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30 11.028c0-.568.46-1.028 1.028-1.028h23.944c.568 0 1.028.46 1.028 1.028V28H30V11.028z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M30 11.028c0-.568.46-1.028 1.028-1.028h23.944c.568 0 1.028.46 1.028 1.028V28H30V11.028z",
  fill: "#E8EAED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 10h26-26zm26 19H30v-2h26v2zm-26-1V10v18zm26-18v18-18z",
  fill: "#DDE0E4",
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("rect", {
  x: "31.98",
  y: "30.879",
  width: "21.989",
  height: "2.069",
  rx: "1.034",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "31.98",
  y: "34.332",
  width: "6.088",
  height: "2.069",
  rx: ".514",
  fill: "#59C3C3"
})), /*#__PURE__*/React.createElement("rect", {
  x: "30.334",
  y: "9.5",
  width: "26",
  height: "31",
  rx: "2.5",
  stroke: "#DDE0E4"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip2_1956_114153)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "59.834",
  y: "10",
  width: "26",
  height: "30",
  rx: "1.028",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("mask", {
  id: "c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M59 11.028c0-.568.46-1.028 1.028-1.028h23.944c.568 0 1.028.46 1.028 1.028V28H59V11.028z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M59 11.028c0-.568.46-1.028 1.028-1.028h23.944c.568 0 1.028.46 1.028 1.028V28H59V11.028z",
  fill: "#E8EAED"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59 10h26-26zm26 19H59v-2h26v2zm-26-1V10v18zm26-18v18-18z",
  fill: "#DDE0E4",
  mask: "url(#c)"
}), /*#__PURE__*/React.createElement("rect", {
  x: "60.98",
  y: "30.879",
  width: "21.989",
  height: "2.069",
  rx: "1.034",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "60.98",
  y: "34.332",
  width: "6.088",
  height: "2.069",
  rx: ".514",
  fill: "#59C3C3"
})), /*#__PURE__*/React.createElement("rect", {
  x: "59.334",
  y: "9.5",
  width: "26",
  height: "31",
  rx: "2.5",
  stroke: "#DDE0E4"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1956_114153"
}, /*#__PURE__*/React.createElement("rect", {
  x: "1.833",
  y: "10",
  width: "25",
  height: "30",
  rx: "2",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_1956_114153"
}, /*#__PURE__*/React.createElement("rect", {
  x: "30.834",
  y: "10",
  width: "25",
  height: "30",
  rx: "2",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2_1956_114153"
}, /*#__PURE__*/React.createElement("rect", {
  x: "59.834",
  y: "10",
  width: "25",
  height: "30",
  rx: "2",
  fill: "#fff"
})))));